import React from 'react'
import Footer from '../../../components/Landing/Footer'
import { SEO } from '../../../components/SEO'

const RefundPolicy = () => {
  return (
    <>
    <SEO 
      title="Refund Policy - WorldoTutor"
      description="Read our refund policy for unused classes. 30-day refund window with 50% refund on un-availed sessions."
      keywords="refund policy, money back, refund procedure, payment refund"
      url="/refund-policy"
      type="website"
      og={{
        type: 'website',
        siteName: 'WorldoTutor',
        locale: 'en_US',
        image: {
          url: '/imgi_1_favicon.png',
          alt: 'Refund Policy - WorldoTutor',
          width: 1200,
          height: 630
        }
      }}
      twitter={{
        card: 'summary_large_image',
        site: '@worldotutor',
        image: {
          url: '/imgi_1_favicon.png',
          alt: 'Refund Policy - WorldoTutor'
        }
      }}
    />
    <div className="bg-white text-gray-800 py-12 px-4 sm:px-6 lg:px-8">
      <div className="container mx-auto">
        <h1 className="text-3xl sm:text-4xl font-bold  mb-8">Refund Policy</h1>
        
        <div className="space-y-6">
          <p>
            We believe in extending top-notch services to our students. Education is the backbone of any nation and students are the future. Our company policies are designed to best cater to students' requirements.
          </p>
          
          <p>
            Furthermore, we provide a flexible approach to students that queries for refunds barely arise. We offer adaptable ways within the time duration of the courses, i.e. unlimited time, change of teacher, change of subjects, transferring current classes to siblings or even to friends who are enrolled or likely to be enrolled for new courses.
          </p>
          
          <p>
            We have academic and non-academic courses and students just love to explore and learn new activities like learning chess, yoga, karate, dance, guitar, flute, piano, and even singing. We don't like to lose our dear students, therefore an immaculate set of policies are framed to best service.
          </p>
          
          <p>
            If anyone still needs a refund, our team is always there to assist with the best possible solution. According to the policy, 50% of the amount is deducted as receiving international payments involves services tax, transaction charges,administrative cost , currency conversion charges, and other costs too. 50% amount is refunded for the un-availed classes. The refund can be claimed within 30 days from the date of avail of the program.
          </p>
          
          <p>
            We suggest contacting us for any help if you experience any problems related to the dissemination of our services.
          </p>
          
          <h2 className="text-2xl sm:text-3xl font-bold pt-6">Refund Procedure</h2>
          
          <p>
            As soon as we receive the request for a refund, we will notify you of the refund status after effective scrutiny of the reason mentioned. Once the refund request is approved, we will forward a refund to the given bank account. You will get the credit within 4-6 working days, pertaining to card/bank policies.
          </p>
        </div>
      </div>
    </div>
    <div className='bg-neutralBlack'>
        <Footer/>
    </div>
    </>
  )
}

export default RefundPolicy
